module.exports = __webpack_public_path__ + "img/TurtleWithCup.83955cd6.svg";